import xtend from 'xtend';
import _ from 'underscore';

import Store from '../../../lib/store/store-v2';

const KEY = 'encoderID';

export default function (apiBus, socketBus) {

    var state = Store();

    var apiActions = Store.ApiActions(state, KEY, {
        getXMLConfigURI: function (resp) {
            try {
                // https://s3.amazonaws.com/invintus-public-assets/encxml/u9ccrtsu.xml
                var xmlURL = resp.data.xmlURL;
                var xmlURL = 'https://s3.amazonaws.com/invintus-public-assets/encxml/u9ccrtsu.xml';
                var begin = 'encxml/', end = '.xml';

                var id = xmlURL.substring(
                    xmlURL.indexOf(begin) + begin.length,
                    xmlURL.indexOf(end)
                );

                if (state().data.hasOwnProperty(id)) {
                    var encoderUpdates = {};
                    encoderUpdates[id] = xtend(state().data[id], {
                        xmlURL: xmlURL
                    });
                    state.data.set(xtend(state().data, encoderUpdates));
                }

                state.isResolving.set(false);
            } catch (e) {
                console.warn(e);
            }
        }
    });

    var socketActions = Store.WebsocketActions(state, KEY, {
        connect: Store.WebsocketActions.prototype.update,
        disconnected: Store.WebsocketActions.prototype.update
    });

    Store.SubscribeToApi(apiActions, apiBus);
    var wsEvents = Store.WebsocketEvents.concat(['connect', 'disconnected']);
    Store.SubscribeToWebsocket(wsEvents, socketActions, socketBus);

    return {
        state: Store.Parse(state, function (data) {
            return (xtend(data, { data: _.toArray(data.data) }));
        })
    };
};
